import React from 'react';
import { Link } from 'react-router-dom';
import './HomeSlider.css';

export default class HomeSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        window.jQuery('.fullwidthbanner').revolution({
            delay: 9000,
            startwidth: 1140,
            startheight: 744,
            hideThumbs: 200,

            thumbWidth: 100,
            thumbHeight: 50,
            thumbAmount: 3,

            navigationType: 'none',
            navigationArrows: 'solo',
            navigationStyle: 'round',

            touchenabled: 'on',
            onHoverStop: 'on',

            navigationHAlign: 'center',
            navigationVAlign: 'bottom',
            navigationHOffset: 0,
            navigationVOffset: 20,

            soloArrowLeftHalign: 'left',
            soloArrowLeftValign: 'center',
            soloArrowLeftHOffset: 20,
            soloArrowLeftVOffset: 0,

            soloArrowRightHalign: 'right',
            soloArrowRightValign: 'center',
            soloArrowRightHOffset: 20,
            soloArrowRightVOffset: 0,

            shadow: 0,
            fullWidth: 'on',
            fullScreen: 'off',
            lazyLoad: 'on',

            stopLoop: 'off',
            stopAfterLoops: -1,
            stopAtSlide: -1,

            shuffle: 'off',

            hideSliderAtLimit: 0,
            hideCaptionAtLimit: 0,
            hideAllCaptionAtLilmit: 0,
            startWithSlide: 0,
        });
    }

    render() {
        return (
            <div id="slider">
                <div className="fullwidthbanner-container">
                    <div className="fullwidthbanner">
                        <ul>
                            <li
                                data-transition="fade"
                                data-slotamount="7"
                                data-masterspeed="300"
                            >
                                <img
                                    src="images/homeSlider/backgrounds/bg-1.jpg"
                                    data-fullwidthcentering="on"
                                    alt="slidebg1"
                                    data-bgfit="cover"
                                    data-bgposition="top center"
                                    data-bgrepeat="no-repeat"
                                />
                                <div
                                    className="tp-caption uppercase big_font_size boldest_font_weight dark_font_color sft start"
                                    data-x="540"
                                    data-y="125"
                                    data-speed="300"
                                    data-start="1600"
                                    data-easing="easeOutExpo"
                                >
                                    <span className="accent-color">
                                        Votre centre d'appel spécialisé,
                                    </span>
                                    <br />
                                    L'expertise en plus
                                </div>
                                <div
                                    className="tp-caption medium_font_size regular_font_weight dark_font_color sfl start"
                                    data-x="540"
                                    data-y="208"
                                    data-speed="300"
                                    data-start="1900"
                                    data-easing="easeOutExpo"
                                >
                                    Acteur engagé auprès des professionnels de
                                    l'imagerie médicale,
                                </div>
                                <div
                                    className="tp-caption mini_font_size light_font_weight gray_font_color sfr start"
                                    data-x="540"
                                    data-y="250"
                                    data-speed="300"
                                    data-start="2200"
                                    data-easing="easeOutExpo"
                                >
                                    STAPMEDIF tisse avec ses clients et
                                    partenaires un lien fort.
                                    <br />
                                    Notre conformité RGPD assure la sécurité de
                                    vos données de santé.
                                </div>
                                <div
                                    className="tp-caption sfb start"
                                    data-x="540"
                                    data-y="314"
                                    data-speed="300"
                                    data-start="2500"
                                    data-easing="easeOutExpo"
                                >
                                    <Link
                                        to={'/about'}
                                        className={'button-slider-v4'}
                                    >
                                        Qui sommes-nous
                                    </Link>
                                </div>
                                <div
                                    className="tp-caption mini_font_size light_font_weight gray_font_color sfr start"
                                    data-x="540"
                                    data-y="380"
                                    data-speed="300"
                                    data-start="2500"
                                    data-easing="easeOutExpo"
                                    style={{
                                        backgroundColor:
                                            'rgba(169, 24, 134, 0.8)',
                                        color: 'white',
                                        fontSize: '22px',
                                        padding: '15px',
                                        borderRadius: '0.5em',
                                        lineHeight: '26px',
                                        minHeight: '0px',
                                        minWidth: '0px',
                                        whiteSpace: 'nowrap',
                                        borderWidth: '0px',
                                        margin: '0px',
                                    }}
                                >
                                    NOUVEAU : STAP-Doc'sécur - Partage sécurisé
                                    de documents digitalisés
                                    <br />
                                    dans le respect du RGPD. En mode autonome ou
                                    connecté à votre
                                    <br />
                                    logiciel métier, envoyez vos documents en
                                    toute sérénité.
                                    <br />
                                    Appelez votre conseiller au 02 85 29 24 24.
                                </div>
                                <div
                                    className="tp-caption sfl start"
                                    data-x="180"
                                    data-y="bottom"
                                    data-speed="1000"
                                    data-start="1000"
                                    data-easing="Power1.easeOut"
                                >
                                    <img
                                        src="images/slide-02-image-01.png"
                                        alt=""
                                    />
                                </div>
                            </li>
                        </ul>
                        <div
                            className="tp-bannertimer"
                            style={{ visibility: 'hidden' }}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }
}

HomeSlider.propTypes = {};



// WEBPACK FOOTER //
// ./src/components/HomeSlider.jsx